module.exports = __webpack_public_path__ + "static/media/YouTubeNegative.85e63126.svg";